import { NodesProxy } from "@/wc/registry/lib/dom/index.js";
import StekzHTMLElement from "@/wc/registry/component/base/index.js";

// Lots of form input elements share logic between them through this
// component.
export default class StekzFormInputElement extends StekzHTMLElement {
    setIsInitialized: (value?: unknown) => void;
    setIsPrefilled: (value?: unknown) => void;

    // Below promise can be used by other components to check if the
    // component has been fully initialized. By doing so, we can be 100% sure
    // that the 'value getter/converter' for the given form-input-* component is
    // used.
    isInitialized = new Promise((resolve) => {
        this.setIsInitialized = resolve;
    });

    // the isPrefilled promise can be used by other components to check if the
    // component has been prefilled by the form
    isPrefilled = new Promise((resolve) => {
        this.setIsPrefilled = resolve;
    });

    constructor() {
        super();

        this.nodes = NodesProxy(this);
    }

    set required(value: string) {
        if (this.nodes.required) {
            this.nodes.required.className =
                value !== "" ? "not-required" : "required";
        }
    }

    set label(value: string) {
        if (this.nodes.label) {
            this.nodes.label.innerText = value;
        }
    }

    set error(value: string) {
        this.showErrorIndicators(value);
        this.updateErrorText(value);
    }

    showErrorIndicators(value: string) {
        const icon = this.nodes.control.querySelector(".icon");
        if (value) {
            this.nodes.control.setAttribute("class", "control has-icons-right");
            this.nodes.input.setAttribute("class", "input is-danger");
            if (!icon) {
                if (this.dataset.appendValue !== undefined) {
                    this.nodes.control.insertAdjacentHTML(
                        "beforeend",
                        `
            <span class="icon is-small" style="right: 40px">
              <i class="fas fa-exclamation-triangle"></i>
            </span>
          `
                    );
                } else {
                    this.nodes.control.insertAdjacentHTML(
                        "beforeend",
                        `
          <span class="icon is-small is-right">
            <i class="fas fa-exclamation-triangle"></i>
          </span>
        `
                    );
                }
            }
        } else {
            this.nodes.control.setAttribute("class", "control");
            this.nodes.input.setAttribute("class", "input");
            if (icon) {
                icon.remove();
            }
        }
    }

    updateErrorText(errorText: string) {
        if (errorText) {
            this.nodes["help-text"].classList.add("is-danger");
            this.nodes["help-text"].innerText = errorText;
        } else {
            // Make sure there is some space reserved to align this form-input
            // with the other form-inputs that might have a help message.
            this.nodes["help-text"].innerHTML = "&nbsp;";
            this.nodes["help-text"].classList.remove("is-danger");
        }
    }

    connectedCallback() {
        // When the connectedCallback is called, the decorator has already
        // attached the template to this component, thus we know that it is
        // initialized. By calling setIsInitialized, other components that are
        // waiting for 'isInitialized' can be sure that this component is ready to
        // be used.
        this.setIsInitialized();
    }
}
